import React from "react";
import zaloIcon from "../assets/img/zalo.png";
import "../styles/zalo-button.css";

const isValidZaloId = (phone) => {
  const zaloRegex = /^[0-9]{8,15}$/;
  return zaloRegex.test(phone);
};

const ZaloButton = ({ phoneNumber }) => {
  if (!isValidZaloId(phoneNumber)) {
    console.error("Số Zalo không hợp lệ!");
    return null;
  }

  const zaloLink = `https://zalo.me/${phoneNumber}`;

  return (
    <a
      href={zaloLink}
      className="zalo-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Liên hệ Zalo"
    >
      <img
        src={zaloIcon}
        alt="Zalo"
        className="zalo-icon"
      />
    </a>
  );
};

export default ZaloButton;
